

import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Parse from './parseConfig';
import Welcome from './components/Welcome';
import Login from './components/Login';
import MainLayout from './components/planhubmain/MainLayout';
import StockLayout from './components/stock/StockLayout';
import BuiltLayout from './components/built/BuiltLayout';
import UsageLayout from './components/usage/UsageLayout';
import RequireAuthRoute from './components/RequireAuthRoute';
import RequireBuiltHomeRoleRoute from './components/RequireBuiltHomeRoleRoute';
import RequireFraemohsRoute from './components/RequireFraemohsRoute';
import './App.css';

import useGuestSessionManager from './components/helpers/guestSessionManager';
import useActivityTracker from './components/helpers/useActivityTracker';



function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}


function AppRoutes() {

  const navigate = useNavigate();


  useGuestSessionManager();  // Handle guest user session expiration. Checks for guest session expiration based on lastActiveAt and times out properly.
  useActivityTracker();  // Update last active timestamp based on real user interaction


  const onUserClick = () => {  // This is a user with an existing account that wants to log in.
    navigate('/login');
  };


  const onLoginSuccess = () => {  // Both guest users and users with accounts will end up here after logging in.
    navigate('/main');
  };


  const updateGuestLastActive = () => {
    const now = new Date().toISOString();
    localStorage.setItem('guestLastActiveAt', now);
    //console.log(`[GuestSession] (App.js) Set lastActiveAt to ${now} on guest login`);
  };


  const onGuestClick = async (redirectTo) => {

    // Use parse cloud function to log in as a guest user. Keeps the guest account credentials away from prying eyes.
    const sessionToken = await Parse.Cloud.run("guestLogin");
    await Parse.User.become(sessionToken);

    updateGuestLastActive();  // This ensures that as soon as the user logs back in, the session timer is reset properly.

    // Redirect to the original path if it was saved
    if (redirectTo) {
      navigate(redirectTo);
      sessionStorage.removeItem('redirectTo'); // Clean up after redirect
    }
    else {
      navigate('/main');
    }
  };



  const handleLogout = async () => {

    try {

      await Parse.User.logOut();

      window.location.href = '/';  // Clear in-memory state and force a hard reload
    }
    catch (error) {
      console.error('Logout failed:', error);
    }
  };



  return (
    <div className="app-container">
      <Routes>
        <Route
          path="/"
          element={
            Parse.User.current()
              ? <Navigate to="/main" />  // If a user is logged in (*)guest or existing account) deliver them straight to /main.
              : <Welcome onGuestLogin={onGuestClick} onUserLogin={onUserClick} />
          }
        />

        <Route path="/login" element={<Login onLogin={onLoginSuccess} />} />
        <Route path="/main" element={<RequireAuthRoute component={() => <MainLayout onLogout={handleLogout} />} />} />
        <Route path="/stock" element={<StockLayout />} />
        <Route path="/built" element={<RequireBuiltHomeRoleRoute component={() => <BuiltLayout onLogout={handleLogout} />} />} />
        <Route path="/usage" element={<RequireFraemohsRoute component={() => <UsageLayout onLogout={handleLogout} />} />} />
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </div>
  );

}

export default App;
